import Article from '../../services/ArticleService';
export default {
  init(instance) {
    document.addEventListener('alpine:init', () => {
      instance.data('ArticleLikes', (entryID, initialCount) => {
        return {
          likes: initialCount,
          liked: localStorage.getItem('liked-' + entryID) === 'true',
          async toggleLikes(event) {
            event.preventDefault();

            await Article.toggleLikes({
              id: entryID,
              liked: this.liked,
            })
              .then(() => {
                this.liked = !this.liked;
                this.likes += this.liked ? 1 : -1;

                localStorage.setItem(
                  'liked-' + entryID,
                  this.liked ? 'true' : '',
                );
              })
              .catch((error) => {
                console.error('Axios error:', error);
              });
          },
        };
      });
    });
  },
};
